{
  "thirdparty": {
    "expedia": {
      "legalModal": {
        "title": "Booking additional travel services",
        "expandTitle": "View more information on insolvency protection",
        "poweredBy": "Powered by"
      }
    }
  },
  "fragments": {
    "expediaHotelsLegislationModal": {
      "localSettings": {},
      "url": "/en/3939006-3939006"
    },
    "expediaHotelsLegislationModalExpanded": {
      "localSettings": {},
      "url": "/en/3938984-3938984"
    },
    "expediaHotelsImage": {
      "localSettings": {},
      "url": "/fi-en/3940154-3940154"
    }
  }
}
